import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import IconButton from "@mui/material/IconButton";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import { Tooltip } from "@mui/material";
import {
  AddPlan,
  PlanImport,
  EditPlan,
  DeletePlan,
} from "../../../assets/RiskManagementIcon";
import { useIncidentResponsePlanContext } from "../../../context/IncidentResponsePlan/IncidentPlanResponceContext";
import RichTextBoxTabPanel from "../../../components/RichTextBoxEditerTabs";
import {
  deleteIncidentResponsePlan,
  downloadIncidentResponsePlan,
  fetchIncidentResponsePlanById,
  updateIncidentResponsePlan,
} from "../helper";
import { useUserContext } from "../../../context/auth/UserContext";
import { useAccessRights } from "../../../utils/useAccessRights";
import { getUserName } from "../../../helper/helper";

export const DisplayResponsePlan = (props: { refreshList: () => void }) => {
  const navigate = useNavigate();
  const incidentResponsePlanAccess = useAccessRights("Incident Response Plan");

  const [incidentResponsePlanDetails, setincidentResponsePlanDetails] =
    useState<any>({});
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });

  const { userId, companyProfileID } = useUserContext();
  const { selectedIncidentResponsePlan, setSelectedIncidentResponsePlan } =
    useIncidentResponsePlanContext();

  const tabDetalis = [
    {
      label: "overview",
      key: "overview",
      id: "tab-overview",
      editerValue: incidentResponsePlanDetails?.overview
        ? incidentResponsePlanDetails.overview
        : "",
    },
    {
      label: "purpose",
      key: "purpose",
      id: "tab-purpose",
      editerValue: incidentResponsePlanDetails?.purpose
        ? incidentResponsePlanDetails.purpose
        : "",
    },
    {
      label: "scope",
      key: "scope",
      id: "tab-scope",
      editerValue: incidentResponsePlanDetails?.scope
        ? incidentResponsePlanDetails.scope
        : "",
    },
    {
      label: "definition",
      key: "definition",
      id: "tab-definition",
      editerValue: incidentResponsePlanDetails?.definition
        ? incidentResponsePlanDetails.definition
        : "",
    },
    {
      label: "Incident Response Team",
      key: "incidentResponseTeam",
      id: "tab-incidentResponseTeam",
      editerValue: incidentResponsePlanDetails?.incidentResponseTeam
        ? incidentResponsePlanDetails.incidentResponseTeam
        : "",
    },
    {
      label: "Preparation",
      key: "preparation",
      id: "tab-preparation",
      editerValue: incidentResponsePlanDetails?.preparation
        ? incidentResponsePlanDetails.preparation
        : "",
    },
    {
      label: "Detection",
      key: "detection",
      id: "tab-detection",
      editerValue: incidentResponsePlanDetails?.detection
        ? incidentResponsePlanDetails.detection
        : "",
    },
    {
      label: "Analysis",
      key: "analysis",
      id: "tab-analysis",
      editerValue: incidentResponsePlanDetails?.analysis
        ? incidentResponsePlanDetails.analysis
        : "",
    },
    {
      label: "Containment",
      key: "containment",
      id: "tab-containment",
      editerValue: incidentResponsePlanDetails?.containment
        ? incidentResponsePlanDetails.containment
        : "",
    },
    {
      label: "Eradication",
      key: "eradication",
      id: "tab-eradication",
      editerValue: incidentResponsePlanDetails?.eradication
        ? incidentResponsePlanDetails.eradication
        : "",
    },
    {
      label: "Recovery",
      key: "recovery",
      id: "tab-recovery",
      editerValue: incidentResponsePlanDetails?.recovery
        ? incidentResponsePlanDetails.recovery
        : "",
    },
    {
      label: "Reporting",
      key: "reporting",
      id: "tab-reporting",
      editerValue: incidentResponsePlanDetails?.reporting
        ? incidentResponsePlanDetails.reporting
        : "",
    },
    {
      label: "Compliance",
      key: "compliance",
      id: "tab-compliance",
      editerValue: incidentResponsePlanDetails?.compliance
        ? incidentResponsePlanDetails.compliance
        : "",
    },
    {
      label: "Related Documents",
      key: "relatedPolicies",
      id: "tab-relatedPolicies",
      editerValue: incidentResponsePlanDetails?.relatedPolicies
        ? incidentResponsePlanDetails.relatedPolicies
        : "",
    },
  ];

  const displayEditPlan = async (details: any) => {
    const date = new Date();
    const payload = {
      ...details,
      isEditedByUser: true,
      isEditedByUserId: userId + "",
      updateBy: userId,
      updateDate: date,
    };

    const resUpdate = await updateIncidentResponsePlan(payload);
    if (resUpdate.succeeded === true) {
      navigate("/incident-response-plan-form");
    }
  };

  const isSelected = () => {
    return (
      selectedIncidentResponsePlan && selectedIncidentResponsePlan.length > 0
    );
  };

  const handleCloseDialog = () => {
    if (dialogState.title === "Success") {
      props.refreshList();
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    } else {
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    }
  };

  const handleEditPlan = async () => {
    const res = await fetchIncidentResponsePlanById(
      incidentResponsePlanDetails.incidentResponseInfoPlanID
    );

    // console.log("handleEditPlan plan", res);
    if (res.isEditedByUser && parseInt(res.isEditedByUserId) !== userId) {
      let userName = await getUserName(res.isEditedByUserId);
      setDialogState({
        title: "Info",
        body: `You are unable to modify this plan because ${userName} has already begun editing it.`,
        action: "Ok",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      displayEditPlan(res);
    }
  };

  const confirmDelete = () => {
    setDialogState({
      title: "Confirmation",
      body: `Are you sure you want to delete <strong>${incidentResponsePlanDetails.version}</strong>?`,
      action: "Delete",
      actionCancel: "Cancel",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };

  const handleDeletePlan = async () => {
    setincidentResponsePlanDetails({});
    setDialogState(() => ({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    }));

    const date = new Date();
    const payload = {
      incidentResponseInfoPlanID:
        incidentResponsePlanDetails.incidentResponseInfoPlanID,
      isDeleted: true,
      updateBy: userId,
      updateDate: date,
    };
    const res = await deleteIncidentResponsePlan(payload);
    // console.log("handleDeletePlan res", payload, res);
    if (res.succeeded === true) {
      setSelectedIncidentResponsePlan([]);
      setDialogState({
        title: "Success",
        body: "Plan successfully deleted",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  };

  useEffect(() => {
    if (isSelected()) {
      setincidentResponsePlanDetails(selectedIncidentResponsePlan[0]);
    } else {
      setincidentResponsePlanDetails({});
    }
  }, [selectedIncidentResponsePlan]);

  return (
    <Fragment>
      <Grid sx={{ height: "100%", width: "100%" }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid xs={4}>
            <h3 style={{ fontWeight: "400" }}>
              Plan Details ({incidentResponsePlanDetails.version})
            </h3>
          </Grid>
          <Grid>
            {/* <Tooltip title="Copy Plan">
              <IconButton aria-label="copy" disabled={!isSelected()}>
                {React.createElement(AddPlan)}
              </IconButton>
            </Tooltip> */}
            <Tooltip title="Download Plan">
              <IconButton
                aria-label="download"
                disabled={
                  !isSelected() || !incidentResponsePlanAccess?.isDownload
                }
                onClick={() =>
                  downloadIncidentResponsePlan(
                    companyProfileID,
                    incidentResponsePlanDetails
                  )
                }
              >
                {React.createElement(PlanImport, {
                  opacity:
                    !isSelected() || !incidentResponsePlanAccess?.isDownload
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Plan">
              <IconButton
                aria-label="edit"
                disabled={
                  !isSelected() || !incidentResponsePlanAccess?.isUpdate
                }
                onClick={handleEditPlan}
              >
                {React.createElement(EditPlan, {
                  opacity:
                    !isSelected() || !incidentResponsePlanAccess?.isUpdate
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Plan">
              <IconButton
                aria-label="delete"
                disabled={
                  !isSelected() || !incidentResponsePlanAccess?.isDelete
                }
                onClick={confirmDelete}
              >
                {React.createElement(DeletePlan, {
                  opacity:
                    !isSelected() || !incidentResponsePlanAccess?.isDelete
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid>
          <h5
            style={{
              margin: "0.5rem 0",
              fontWeight: "400",
            }}
          >
            <RichTextBoxTabPanel
              readonly={true}
              tabs={tabDetalis}
              handleTabEditerChange={() => {}}
            />
          </h5>
        </Grid>
      </Grid>
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeletePlan}
          handleCancel={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
